<div class="dtf-accountdetails">
<mat-dialog-content>
  @if(this.autopaydialog ==='one'){
    <h2><b>AutoPay</b></h2>
    <p>If selected account(s) is related to other accounts under the same invoice or billing address, the bank details for all accounts will be updated. To update a single account please contact Customer Service at 800-222-4221 or Fleet Services at 877-294-9679. Would you like to continue?</p>
  } 
  @if(this.autopaydialog ==='two'){
    <h2><b>Bank Profile Warning</b></h2>
    <p>Based on the information provided, the bank account from which the debit is to be made is a commercial account and the name on the bank account is different from the name on the account with Daimler Truck Financial Services. By clicking on "I agree” below, you acknowledge and agree that you are authorized without limitation to initiate electronic debit entries from the bank account at the times and in the amounts indicated and you will provide written evidence of such authorization upon request.</p>
  }
  @if(this.autopaydialog ==='three'){
    <h2><b>AutoPay Authorization</b></h2>
    <p>Please read and accept the agreement below.</p>
    <p>Upon acceptance by Daimler Truck Financial Services USA LLC, its successors and assigns ("Daimler Truck Financial Services"), of this authorization and a properly voided check/draft, preprinted with all the account holder name(s) and address, Daimler Truck Financial Services is authorized by the account holder ("I", "me" or "my") to initiate electronic debit entries or effect a charge by any other commercially accepted means to my account held at the financial institution listed below for the amount of the monthly payment described in my lease or retail installment sale contract with Daimler Truck Financial Services ("Agreement"). I authorize and request the financial institution listed on this form to honor such debit entries to the contract number listed on this form. In addition, this authorization includes all other amounts due pursuant to the terms of the Agreement, which may vary from the amount of the regularly scheduled payment to an amount exceeding the regularly scheduled payment by $100. I understand that Daimler Truck Financial Services will notify me of any changes in the dollar amount to be debited from my account where the debited amount will exceed the regularly scheduled payment by more than $100. This authorization will remain in force until either Daimler Truck Financial Services or I have received reasonable and advance written notice of cancellation from the other party or until satisfaction in full of all my obligations under the Agreement. If my payment due date falls on a bank holiday or a weekend, my payment will be deducted on the next business day after the due date. If my account is a lease, my payment will be deducted on the scheduled due date and will continue up to and including the last lease payment due on my account. Otherwise, payments will be deducted on the scheduled due date until the next to last payment due on my account; I will receive a separate bill for the last payment. I may receive a separate bill for charges associated with the return of my vehicle (i.e., excess wear and use, excess mileage, etc.).</p>
  }
  @if(this.autopaydialog ==='four'){
    <p>Your Daimler Truck Financial Services Auto Pay profile has been successfully submitted and saved. This profile will be used for all your future Auto Pay transactions for this account.</p>
    <p>Please review the Auto Pay effective date per account; If you have a due date before then, you must make the payment manually.</p>
    @for (contract of contractNumberList; track contract; let first = $first){
      <div class="listcolumn_popup">
        @if(isFirst){
          <h4>Contract Number(s)</h4>
        }
        <p>{{contract.contractNumber}}</p>
      </div>
      <div class="listcolumn_popup">
        @if(isFirst){
          <h4>Effective Date</h4>
        }
        <p>{{contract.effectiveDate}}</p>
      </div>
    }
  }
  @if(this.autopaydialog ==='error'){
    <h2><b>Error</b></h2>
    <p><b>{{errorMessage}}</b></p>
  }
  @if(this.autopaydialog ==='six'){
    <h2><b>AutoPay Termination Confirmation</b></h2>
    <p>This action will stop Auto Pay withdrawls on the selected accounts. Terminations will take effect five business days after this request is submitted. If you have a due date within this window, Auto Pay will be disabled on the following due date.</p>
  }
  @if(this.autopaydialog ==='seven'){
    <h2><b>AutoPay Termination Completed</b></h2>
    <p>Your AutoPay Termination request has been submitted.</p>
    <p>Terminations will take effect 5 business days after request submission. If you have a due date within this window, Auto Pay will be disabled on the following due date.</p>
  } 
</mat-dialog-content>

<mat-dialog-actions>
  @if(this.autopaydialog ==='one' || this.autopaydialog ==='two' || this.autopaydialog ==='three'){
    <button mat-button (click)="autoPayRedirect($event)" mat-dialog-close>Cancel</button>
    <button mat-button mat-dialog-close>I Agree</button>
   }
  
   @if(this.autopaydialog ==='error'){
    <button mat-button (click)="autoPayRedirect($event)" mat-dialog-close>Cancel</button>
    <button mat-button mat-dialog-close>Continue</button>
    }
  
  
    @if(this.autopaydialog ==='four'){
    <button mat-button  (click)="autoPayRedirect($event)" mat-dialog-close>I Agree</button>
    }
  
    @if(this.autopaydialog ==='six'){
    <button mat-button (click)="autoPayRedirect($event)" mat-dialog-close>Cancel</button>
    <button mat-button mat-dialog-close>Terminate</button>
      }
  
      @if(this.autopaydialog ==='seven'){
    <button mat-button (click)="autoPayRedirect($event)" mat-dialog-close>Continue</button>
      }
</mat-dialog-actions>

</div>